// @flow
import styled from 'styled-components';
import { getFont } from '@finect/tabular-utils/getFont';
import { maxMediaQueries } from '@finect/tabular-utils/mediaQueries';

/* stylelint-disable */
/* eslint-disable */

export const Icon: any = styled.span`
  padding: 9px;
  border-right: 1px solid ${({ theme }) => theme.colors.uiM};
  margin-right: 12px;
  transition: all 0.25s ease;

  :hover,
  :focus {
    border-color: ${({ theme }) => theme.colors.accent1L};
  }

  svg {
    display: block;
    width: 24px;
    height: 24px;
  }
`;

export const OptionsInner: any = styled.div`
  position: relative;
  display: grid;
  grid-template-rows: 1fr 0.8fr 0.6fr auto;
  padding: 2rem;
  border: 2px solid ${({ theme }) => theme.colors.ui};
  border-radius: 4px;

  > h4 {
    ${getFont(2)}
    font-weight: 600;
    margin-bottom: 18px;
  }

  > span:before {
    content: ' ';
    display: inline-block;
    width: 10px;
    height: 10px;
    border-radius: 50%;
    margin-right: 10px;
    border: 2px solid ${({ theme }) => theme.colors.primary};

    // inner shadow simulating an inner border
    box-shadow: inset 0 0 0 1px ${({ theme }) => theme.colors.terciaryLL};
  }

  > div {
    ${getFont(3)}
    font-weight: 700;
  }

  > div > span {
    ${getFont(0)}
    font-weight: 400;
    color: ${({ theme }) => theme.colors.terciaryD};
    ${({ color }) => color && `color: ${color};`}
  }

  ${({ background }) => background && `background: ${background};`}
  ${({ color }) => color && `color: ${color};`}

  ${({ plus, color, color2 }) =>
    plus &&
    `
    display: flex;
    flex-direction: column;

    border: none;
    border-radius: 0;

    svg {
      margin-bottom: 18px;
    }

    > h4 {
      font-weight: 300;
      ${getFont(3)}
      ${color2 && `color: ${color2};`}

      b {
        font-weight: 500;
      }
    }

    .price {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      font-weight: 300;
      ${color2 && `color: ${color2};`}
    }
      
    .bullet {
      font-weight: 300;
      ${getFont(1)}

      b {
        font-weight: 600;
      }
      
      :before {
        content: ' ';
        display: inline-block;
        width: 6px;
        height: 6px;
        margin-bottom:2px;
        border-radius: 50%;
        margin-right: 10px;
        border: 4px solid ${color};
      }
    }
  `}

  ${maxMediaQueries.phablet`
    ${({ plus }) =>
      plus &&
      `
      > h4 {
        ${getFont(2)}
      }
    `}
  `}
`;

export const Bullets: any = styled.div`
  display: flex;
  flex-direction: column;
  margin: 20px 0;
  padding-left: 10px;

  .bullet {
    ${({ fontSize }) => getFont(fontSize)}
    opacity: 0.9;

    ${maxMediaQueries.phablet`
      ${({ fontSize }) => getFont(fontSize - 2)}
    `}
  }
`;

export const Expand: any = styled.div`
  position: relative;
  flex-grow: 1;
  width: 100%;
  height: 1px;
`;

export const Price: any = styled.h5`
  ${({ priceFontSize }) => getFont(priceFontSize || 3)}
  ${({ priceFontWeight }) => priceFontWeight && `font-weight: ${priceFontWeight};`}
  ${({ strikethrough }) => strikethrough && 'text-decoration: line-through;'}

  span {
    display: inline-block;
    vertical-align: middle;
    margin-left: 4px;
    ${({ priceFontSize }) => getFont(priceFontSize ? priceFontSize - 2 : 1)}
    font-weight: 200;
  }
`;

export const ProfDisclaimer: any = styled.div`
  margin-top: 20px;
  text-align: center;

  span {
    opacity: 0.8;
  }

  p {
    ${getFont(0)}
    font-weight: 400;

    a {
      font-weight: 500;
      color: inherit;
      text-decoration: underline;
    }
  }
`;

export const ButtonContainer: any = styled.div`
  // absolute outside of its card at the bottom
  ${({ absolute }) =>
    absolute
      ? `
    position: absolute;
    bottom: -80px;
    left: 0;
    right: 0;
    `
      : 'margin-top: 8px;'}

  transition: all 0.25s ease;

  width: 100%;
  display: flex;
  justify-content: center;

  a,
  button {
    text-align: center;
    ${getFont(1)}
    font-weight: 400;
    color: ${({ theme, color }) => color || theme.colors.font};

    padding: 4px 30px;
    background: ${({ theme, background }) => background || theme.plus.secondary};
    border-radius: 4px;
    border: none;
    cursor: pointer;
  }
`;

export const Option: any = styled.button`
  width: 100%;
  text-align: center;

  padding: 12px 16px;
  background-color: ${({ theme }) => theme.colors.primary};
  border-radius: 2px;
  font-weight: 500;
  color: #fff;
`;

export const PromoBadge: any = styled.div`
  background: linear-gradient(135deg, #ffd700 0%, #ffdf00 100%);
  border-radius: 8px;
  padding: 12px 26px;
  margin: auto;
  display: flex;
  align-items: center;
  margin-top: 36px;
  color: #1a1a1a;
  border: 1px solid rgba(255, 215, 0, 0.5);
  max-width: 500px;

  .asterisk {
    font-size: 28px;
    margin-right: 12px;
    line-height: 0.8;
    color: #000;
    padding-top: 8px;
    align-self: start;
  }

  p {
    margin: 0;
    font-weight: 700;
    ${getFont(0)}
    line-height: 1.3;

    ${maxMediaQueries.phablet`
      ${getFont(-1)}
    `}
  }
`;

/* stylelint-enable */
/* eslint-enable */
